import React from 'react';
import { useRolePermissions } from '../../common/hooks/useRolePermissions';
import type { AssetCapabilityAction } from '../../generated/api/assetCapabilityAction.js';
import type { Capabilities } from '../../generated/api/capabilities.js';

interface PermissionGuardProps {
  assetType: keyof Capabilities;
  action: AssetCapabilityAction;
  assetId?: string;
  children: React.ReactNode;
}

export const PermissionGuard = ({ assetType, action, assetId, children }: PermissionGuardProps) => {
  const { hasPermission } = useRolePermissions();
  if (!hasPermission(assetType, action, assetId)) {
    return null;
  }
  return <>{children}</>;
};
